import { onboardingStore } from "../stores";

export const useOnboardingStore = () => onboardingStore;
